import { Pipe, PipeTransform } from '@angular/core';
import { ContactosService } from '../../services/contactos.service';

@Pipe({
    name: 'propiedadContacto' // nombre del pipe en las directivas
})

export class PropiedadContactoPipe implements PipeTransform {

    constructor(public contactoService:ContactosService){}

    // Métdodo a implementar siempre
    transform(idContacto:string, propiedad:string):any{
        return this.contactoService.obtenerPropiedadContacto(idContacto, propiedad).valueChanges().take(1);
    }
}


// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/propiedad-contacto.pipe.ts